import { onMounted, onUpdated, onBeforeUnmount, ref, type Ref } from 'vue'

export function textIsOmitted(full: string, shown: string, clipped: boolean): boolean {
  return clipped || Boolean(full && shown && full.trim() !== shown.trim())
}
// 只观察主行文字是否被截断，不读取展开区，也不改变记录或权限。
export function useOmittedOrderFields(root: Ref<HTMLElement | null | undefined>, enabled: () => boolean) {
  const omitted = ref<Record<string, string[]>>({})
  const rendered = ref<Record<string, Record<string,string>>>({})
  let frame = 0, stopped = false, mutation: MutationObserver | undefined, resize: ResizeObserver | undefined
  const measure = () => {
    frame = 0
    if (stopped || !enabled() || !root.value) return
    const next: Record<string, string[]> = {}
    const nextText: Record<string, Record<string,string>> = {}
    root.value.querySelectorAll<HTMLElement>('tr[data-detail-row]').forEach(row => {
      if (row.closest('[data-action-scope]') !== root.value) return
      const keys: string[] = []
      const textValues: Record<string,string> = {}
      row.querySelectorAll<HTMLElement>('td[data-order-fit-key]').forEach(cell => {
        const key = cell.dataset.orderFitKey
        if (!key) return
        const text = cell.querySelector<HTMLElement>('.list-text')
        const value = text?.querySelector<HTMLElement>('.list-text-value')
        textValues[key]=text?.title || cell.textContent?.trim() || ''
        const nodes = [cell, ...Array.from(cell.querySelectorAll<HTMLElement>('*'))]
        const clipped = nodes.some(node => {
          if (!node.clientWidth || !node.getClientRects().length || node.closest('button,svg') || !node.textContent?.trim()) return false
          const style = getComputedStyle(node)
          return (['hidden', 'clip'].includes(style.overflowX) && node.scrollWidth > node.clientWidth + 1)
            || (['hidden', 'clip'].includes(style.overflowY) && node.scrollHeight > node.clientHeight + 1)
        })
        if (textIsOmitted(text?.title || '', value?.textContent || '', clipped)) keys.push(key)
      })
      next[row.dataset.detailRow!] = keys
      nextText[row.dataset.detailRow!] = textValues
    })
    if (JSON.stringify(next) !== JSON.stringify(omitted.value)) omitted.value = next
    if (JSON.stringify(nextText) !== JSON.stringify(rendered.value)) rendered.value = nextText
  }
  const schedule = () => { if (!stopped && enabled() && !frame) frame = requestAnimationFrame(measure) }
  onMounted(() => {
    if (root.value) {
      mutation = new MutationObserver(schedule)
      mutation.observe(root.value, { subtree: true, childList: true, characterData: true })
      resize = new ResizeObserver(schedule); resize.observe(root.value)
    }
    window.addEventListener('resize',schedule)
    document.fonts?.ready.then(schedule)
    schedule()
  })
  onUpdated(schedule)
  onBeforeUnmount(() => { stopped = true; window.removeEventListener('resize',schedule); mutation?.disconnect(); resize?.disconnect(); cancelAnimationFrame(frame) })
  return { omitted, rendered }
}
